import { LocaleStorageManager } from "./localstorage.manager";
import { LocaleStorageKeys } from "./localstorage.types";

export const localeStorageManager = new LocaleStorageManager();

const APPLICATION_STORAGE_KEYS_TO_PRESERVE = [
  // Temporary campaign state: remove this preservation after the 2026-08-31 expiration.
  LocaleStorageKeys.CHS_2858_ONBOARDING_DISMISSALS,
] as const;

export const clearApplicationStorage = (
  storageManager: LocaleStorageManager = localeStorageManager,
) => {
  storageManager.clear(APPLICATION_STORAGE_KEYS_TO_PRESERVE);
};
